import { useState } from "react";
import SideMenu from "../../../components/organisms/SideMenu";
import Systemlogs from "./Systemlogs";
import Coming_soon from "../../../assets/coming_soon_1.svg"

interface MenuItem {
  id: number;
  name: string;
}

export default function Logs() {
  const MenuItems: MenuItem[] = [
    { id: 11, name: "System Logs" },
    { id: 17, name: "App Logs" },
  ];

  const [activeMenuItem, setActiveMenuItem] = useState<string>("System Logs");

  return (
    <div className="flex">
      <SideMenu />
      <div className="p-6 bg-background w-full space-y-6">
        <div className="flex items-center space-x-10">
          <div className="space-y-1">
            <h1 className="font-primary text-[32px]">Logs</h1>
            <p>View your whats hapenning on your website</p>
          </div>
        </div>

        <div className="flex space-x-4">
          {MenuItems.map((item) => (
            <p
              key={item.id}
              onClick={() => setActiveMenuItem(item.name)}
              className={`border border-primary p-2 px-4 rounded hover:bg-primary hover:text-white duration-300 hover:cursor-pointer ${
                activeMenuItem === item.name
                  ? "bg-primary text-white"
                  : "bg-primary/[.10]"
              }`}
            >
              {item.name}
            </p>
          ))}
        </div>

        {activeMenuItem === "System Logs" && (
          <div>
            <Systemlogs />
          </div>
        )}
        {activeMenuItem === "App Logs" && (
          <div className="w-full h-[70%] flex items-center justify-center font-primary text-[2rem]">
            <img className="w-[50%]" src={Coming_soon} alt="coming_soon"/>
          </div>
        )}
      </div>
    </div>
  );
}
